import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            读者评论
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            动漫爱好者真实评价与反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/60"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                      {comment.name}
                    </h3>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">
                      {comment.time}
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {comment.content}
                  </p>
                  <div className="mt-3 flex items-center gap-1.5 text-foreground-500">
                    <i className="ri-thumb-up-line text-sm"></i>
                    <span className="text-xs">{comment.likes.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}